import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 md:py-24 bg-brand-dark" data-id="element-122" data-mp="1o2vfqkp72f4g">
      <div className="container mx-auto px-4" data-id="element-123" data-mp="22368xudz85ss">
        <div className="max-w-3xl mx-auto text-center" data-id="element-124" data-mp="2223ghi109var">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex flex-col items-center" data-id="element-125" data-mp="1x4l9hx6jtq5e">
            <ShieldCheck className="w-16 h-16 md:w-20 md:h-20 text-brand-light mb-6" data-id="element-126" data-mp="1j5c47sjvsgg7" />

            <h2 className="text-2xl md:text-4xl font-bold mb-8 font-[Poppins,_sans-serif]" data-id="element-127" data-mp="1ecsqmvl71lbe">
              GARANTÍA 21 DÍAS — SIN PREGUNTAS
            </h2>

            <div className="w-full border-2 border-brand-green/40 rounded-2xl p-8 md:p-12 mb-6" data-id="element-128" data-mp="qlwtrk1vrzxa">
              <p className="text-base md:text-lg text-gray-300 mb-4" data-id="element-129" data-mp="lnbz005ee8g8">
                Abrís los volúmenes. Seguís el sistema.
              </p>
              <p className="text-base md:text-lg text-gray-300 mb-6" data-id="element-130" data-mp="txkuz618zc15">
                Si en 21 días no es lo que esperabas:
              </p>
              <p className="text-3xl md:text-4xl font-bold text-brand-light mb-3 font-[Poppins,_sans-serif]" data-id="element-131" data-mp="yrfm2uj6mta9">
                Devolución del 100%
              </p>
              <p className="text-lg md:text-xl font-bold text-white" data-id="element-132" data-mp="61yyca6ic0kd">
                sin formularios, sin drama.
              </p>
            </div>

            <p className="text-sm text-gray-400" data-id="element-133" data-mp="f1bxoa0x38rd">
              Tasa de devoluciones: menos del 1%.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}